export default "__VITE_ASSET__Bk39FNQF__"